import {TypeConstant} from "./TypeConstant";

const initStat = {
    language :'ar',

}

const TranslationReducer = (state = initStat , action) => {
    switch (action.type) {
        case TypeConstant.English: return {language : action.payload}
        case TypeConstant.Arabic: return { language : action.payload}

        default: return state;
    }
}

export default TranslationReducer;
